import createIcon from '../../createIcon';

/**
 * @component @name HomeRepairService
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTZIMTZWMTVIOFYxNkg2VjE1SDJWMjBIMjJWMTVIMThWMTZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjAgOEgxN1Y2QzE3IDQuOSAxNi4xIDQgMTUgNEg5QzcuOSA0IDcgNC45IDcgNlY4SDRDMi45IDggMiA4LjkgMiAxMFYxNEg2VjEySDhWMTRIMTZWMTJIMThWMTRIMjJWMTBDMjIgOC45IDIxLjEgOCAyMCA4Wk0xNSA4SDlWNkgxNVY4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HomeRepairService = createIcon('HomeRepairService', [
  ['path', { d: 'M18 16H16V15H8V16H6V15H2V20H22V15H18V16Z', key: '1ogd11' }],
  [
    'path',
    {
      d: 'M20 8H17V6C17 4.9 16.1 4 15 4H9C7.9 4 7 4.9 7 6V8H4C2.9 8 2 8.9 2 10V14H6V12H8V14H16V12H18V14H22V10C22 8.9 21.1 8 20 8ZM15 8H9V6H15V8Z',
      key: '1s3jdq',
    },
  ],
]);

export default HomeRepairService;
